import React from "react";
import { useShow } from "@refinedev/core";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShowPage } from "@/components/crud";
import { DescriptionList, DescriptionItem } from "@/components/ui/description-list";
import { IAddress } from "../../types";

export const AddressShow: React.FC = () => {
  const queryResult = useShow<IAddress>();
  const { data, isLoading } = queryResult.query;
  const record = data?.data;

  const getTypeVariant = (type: string) => {
    const variants: Record<string, "info" | "success" | "warning" | "secondary"> = {
      billing: "info",
      shipping: "success",
      office: "warning",
      other: "secondary",
    };
    return variants[type] || "secondary";
  };

  return (
    <ShowPage isLoading={isLoading}>
      <Card>
        <CardHeader>
          <CardTitle>Address Information</CardTitle>
        </CardHeader>
        <CardContent>
          <DescriptionList columns={2} bordered>
            <DescriptionItem label="Street Address">{record?.street}</DescriptionItem>
            <DescriptionItem label="City">{record?.city}</DescriptionItem>
            <DescriptionItem label="State/Province">{record?.state || "N/A"}</DescriptionItem>
            <DescriptionItem label="Postal Code">{record?.postal_code || "N/A"}</DescriptionItem>
            <DescriptionItem label="Country">{record?.country}</DescriptionItem>
            <DescriptionItem label="Address Type">
              <Badge variant={getTypeVariant(record?.address_type || "other")}>
                {record?.address_type?.toUpperCase() || "OTHER"}
              </Badge>
            </DescriptionItem>
            <DescriptionItem label="Primary Address">
              <Badge variant={record?.is_primary ? "success" : "secondary"}>
                {record?.is_primary ? "Yes" : "No"}
              </Badge>
            </DescriptionItem>
            <DescriptionItem label="Latitude">{record?.latitude || "N/A"}</DescriptionItem>
            <DescriptionItem label="Longitude">{record?.longitude || "N/A"}</DescriptionItem>
            <DescriptionItem label="Created At">
              {record?.created_at ? new Date(record.created_at).toLocaleDateString() : "N/A"}
            </DescriptionItem>
            <DescriptionItem label="Updated At">
              {record?.updated_at ? new Date(record.updated_at).toLocaleDateString() : "N/A"}
            </DescriptionItem>
          </DescriptionList>
        </CardContent>
      </Card>
    </ShowPage>
  );
};
